export default __webpack_public_path__ + "static/media/w.1b6e24ae.mp4";